var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6.73134C20.3386 7.025 19.6265 7.22359 18.8796 7.31233C19.6424 6.85599 20.2277 6.1324 20.5034 5.27043C19.7892 5.69296 19 6.00035 18.1569 6.16514C17.4849 5.44789 16.5246 5 15.4617 5C13.4237 5 11.7702 6.65317 11.7702 8.6919C11.7702 8.98134 11.8019 9.26233 11.8653 9.53275C8.79609 9.37852 6.07554 7.91021 4.25304 5.67394C3.93502 6.22113 3.7533 6.85599 3.7533 7.53204C3.7533 8.81233 4.40518 9.94261 5.3962 10.6049C4.79187 10.587 4.22134 10.419 3.72266 10.1444V10.1898C3.72266 11.9792 4.99577 13.4718 6.68621 13.8099C6.37665 13.8965 6.05018 13.9398 5.71315 13.9398C5.47544 13.9398 5.243 13.9176 5.01796 13.8743C5.48811 15.3405 6.85102 16.4085 8.46751 16.437C7.2039 17.4278 5.61067 18.0183 3.88114 18.0183C3.5832 18.0183 3.28843 18.0014 3 17.9676C4.63444 19.0134 6.57633 19.625 8.66085 19.625C15.4543 19.625 19.168 14 19.168 9.12077C19.168 8.96021 19.1648 8.79965 19.1585 8.64225C19.8801 8.12148 20.5066 7.47183 21 6.73134Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLine);
export default __webpack_public_path__ + "static/media/TwitterLine.975ed077.svg";
export { ForwardRef as ReactComponent };